module.exports = __webpack_public_path__ + "media/mypage/images/service/icon_002-b43a7a631942bedfc17c53596d376c8d.png";